import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable()
export class Configuration {
  private readonly map_provider = environment.mapProvider;
  private readonly google_maps_config = environment.google_maps;

  public get googleMapsConfiguration() {
    return this.google_maps_config;
  }
}
